import styled from "styled-components";

export const ImageSliderEditorContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 8px 48px;
  box-sizing: border-box;
  align-items: start;
`;
